import React, { Component } from 'react'
import Heading from "../containers/Heading/Heading";
import i18next from "i18next";
import { ClipLoader } from "react-spinners";
import FooterNav from '../components/FooterNav/FooterNav';
import { config } from '../_config'
import { CaptureEvent, CapturePage } from "../_helpers/googleAnalytics";

class License extends Component {
    constructor(props){
        super(props);
        document.title=`Coke & Go ${config.countryName} | viewlicense`;
        CapturePage({hitType:"pageview",page:"/viewlicense"})   
    }
    render() {
        return (
            <div className="LoginSCreen">
                <div className="container">
                    <Heading title={i18next.t("ViewLicense")} firstIcon={true} secondIcon={false} backLink="/Support" LinkIcon="back"/>
                    <div className="row">
                        <div className="col-12">
                            <div className="bg-white p-2" style={{minHeight:'calc(100vh - 80px)',position:'relative'}}>
                                <p>{i18next.t("LicenseSubHeading")}</p>

                                <h6><a className="text-danger" href='https://www.npmjs.com/package/react-pdf' target="_blank">react-pdf License</a></h6>
                                <p>The MIT License (MIT)</p>
                                <h6><a className="text-danger" href='https://www.npmjs.com/package/react-qr-reader' target="_blank">react-qr-reader License</a></h6>
                                <p>The MIT License (MIT)</p>
                                <h6><a className="text-danger" href='https://www.npmjs.com/package/react-facebook-login' target="_blank">react-facebook-login</a></h6>
                                <p>The MIT License (MIT)</p>
                                <h6><a className="text-danger" href='https://www.npmjs.com/package/react-apple-signin-auth' target="_blank">react-apple-signin-auth</a></h6>
                                <p>The MIT License (MIT)</p>
                                <h6><a className="text-danger" href='https://www.npmjs.com/package/@google-cloud/vision' target="_blank">@google-cloud/vision</a></h6>
                                <p>The MIT License (MIT)</p>
                                <h6><a className="text-danger" href='https://www.npmjs.com/package/@loginid/sdk' target="_blank">@loginid/sdk</a></h6>
                                <p>The MIT License (MIT)</p>
                                <div className="copyright">
                                    {/* &copy; */}
                                </div>
                            </div>
                            <FooterNav /> 
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default  License;